// extracted by mini-css-extract-plugin
module.exports = {"Scrollable":"Summary_Scrollable__3-DKf","Animated":"Summary_Animated__28onE"};